export default "__VITE_ASSET__DkvaPZ5v__"